import type { InputHTMLAttributes, ReactNode } from 'react';

import './chip.css';

export type PropsChip = {
  rotulo: string;
  /** Decorativo: quem nomeia o chip é o `rotulo`. */
  icone?: ReactNode;
  /** Apelido de `checked`, no vocabulário do resto do design system. */
  selecionado?: boolean;
} & InputHTMLAttributes<HTMLInputElement>;

export function Chip({
  rotulo,
  icone,
  selecionado,
  checked,
  defaultChecked,
  className,
  ...resto
}: PropsChip) {
  // Um dos dois manda; nenhum dos dois deixa o rádio solto (não controlado),
  // que é o caso do formulário puro. Passar `checked={false}` a um campo sem
  // `onChange` é o que faz o React reclamar de campo controlado sem dono.
  const controlado = selecionado ?? checked;
  const marcado = controlado ?? Boolean(defaultChecked);
  return (
    <label
      className={className ? `ds-chip ${className}` : 'ds-chip'}
      data-selecionado={marcado ? 'sim' : 'nao'}
    >
      <input
        // Visualmente oculto, jamais `display: none`: o rádio precisa
        // continuar focável, navegável por setas e visível ao VoiceOver.
        className="visualmente-oculto"
        checked={controlado}
        defaultChecked={defaultChecked}
        {...resto}
        // Depois do espalhamento: o chip é um rádio por definição, e nenhum
        // chamador pode transformá-lo noutra coisa.
        type="radio"
      />
      {icone ? (
        <span className="ds-chip__icone" aria-hidden="true">
          {icone}
        </span>
      ) : null}
      <span className="ds-chip__rotulo">{rotulo}</span>
      {/* A seleção não vai só na cor: a marca é a forma que sobra em
          monocromia, sob contraste alto e ao sol. */}
      {marcado ? (
        <span className="ds-chip__marca" aria-hidden="true">
          ✓
        </span>
      ) : null}
    </label>
  );
}
